module.exports = __webpack_public_path__ + "img/long.21b5aab2.png";